var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 0.0684378C11.5096 0.125173 11.5867 0.21342 11.6287 0.318761C11.6707 0.424103 11.6751 0.540312 11.6411 0.648405L9.80743 6.50007H13.1907C13.2902 6.50003 13.3874 6.52859 13.4705 6.58222C13.5536 6.63585 13.6189 6.7122 13.6583 6.80185C13.6977 6.8915 13.7095 6.99052 13.6923 7.08669C13.6751 7.18286 13.6295 7.27197 13.5613 7.34302L5.41617 15.8425C5.33736 15.9248 5.23248 15.9785 5.11864 15.9948C5.0048 16.0111 4.8887 15.989 4.78927 15.9322C4.68984 15.8753 4.61294 15.7871 4.5711 15.6818C4.52927 15.5766 4.52496 15.4605 4.55889 15.3526L6.39257 9.4999H3.00928C2.90985 9.49994 2.81259 9.47138 2.7295 9.41775C2.6464 9.36413 2.58112 9.28778 2.54171 9.19813C2.50229 9.10848 2.49047 9.00945 2.5077 8.91328C2.52493 8.81711 2.57046 8.728 2.63867 8.65695L10.7838 0.157433C10.8625 0.0752366 10.9673 0.0216091 11.0809 0.00526999C11.1946 -0.0110691 11.3106 0.010841 11.41 0.0674379V0.0684378Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.2562589943069e7deaf094c6532be3b4.svg";
export { ForwardRef as ReactComponent };